<template>
    <div v-loading='loading'>

        <!-- 国际物流单号 -->
        <el-input placeholder="请输入国际物流单号" size='mini' style="width:150px; margin: 0 10px 20px 0" v-model="gjinput"></el-input>

        <!-- 店铺 -->
        <el-select v-model="sitevalue" clearable placeholder="请选择店铺" size='mini' style="width:130px; margin-right: 10px">
            <el-option
            v-for="item in Site"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>

        <!-- 订单id -->
        <el-input placeholder="请输入订单id" size='mini' style="width:110px; margin: 0 10px 20px 0" v-model="ddinput"></el-input>
        
        <!-- 包裹状态 -->
        <el-select v-model="packagevalue" clearable placeholder="请选择包裹状态" size='mini' style="width:150px; margin-right: 10px">
            <el-option
            v-for="item in packagestatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>

        <!-- <el-select v-model="packagevalue" multiple collapse-tags clearable placeholder="请选择包裹状态" size='mini' style="width:150px; margin-right: 10px">
            <el-option
            v-for="item in packagestatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select> -->

        <el-button size='mini' type="primary" @click="search">搜索</el-button>

        <!-- <el-button size='mini' type="primary" @click="search">搜索</el-button> -->
        <!-- <el-button size='mini' plain>全部({{this.Total}})</el-button>
        <el-button size='mini' plain type='warning' @click='Dddq'>到达待取({{this.dddq}})</el-button>
        <el-button size='mini' plain @click='Ysgj'>运输过久({{this.ysgj}})</el-button>
        <el-button size='mini' plain type='danger' @click='Knyc'>可能异常({{this.knyc}})</el-button>
        <el-button size='mini' plain type='primary' @click='Ystz'>运输途中({{this.ystz}})</el-button>
        <el-button size='mini' plain type='success' @click='Cgqs'>成功签收({{this.cgqs}})</el-button>
        <el-button size='mini' plain type='info' @click='Tdsb'>投递失败({{this.tdsb}})</el-button> -->

        <!-- 页面数据 -->
        <el-table
        height="730"
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
            :data="tableData"
            border
            style="border: 1px solid #000000;width: 100%">

            <el-table-column
            prop="int_no"
            label="国际物流单号"
            width="140">
            </el-table-column>

            <el-table-column
            prop="site"
            label="店铺"
            width="120">
            </el-table-column>

            <el-table-column
            prop="ID_"
            label="订单id"
            width="80">
            </el-table-column>

            <el-table-column
            prop="status"
            label="订单状态"
            width="80">
            </el-table-column>

            <el-table-column
            prop="date_paid_gmt"
            label="付款时间"
            width='100'>
            </el-table-column>

            <el-table-column
            prop="created_at"
            label="发货时间"
            width='100'>
            </el-table-column>

            <el-table-column
            prop="update_date"
            label="物流信息最新更新时间"
            width='100'>
            </el-table-column>

            <el-table-column
            prop="destination"
            label="目的国"
            width='50'>
            </el-table-column>

            <el-table-column
            prop="shiptype"
            label="物流方式"
            width='70'>
            </el-table-column>

            <el-table-column
            prop="delivery_status"
            label="包裹状态"
            width='100'>
            </el-table-column>

            <el-table-column
            prop="substatus"
            label="包裹子状态"
            width='150'>
            </el-table-column>

            <el-table-column
            prop="transit_time"
            label="运输时长"
            width='50'>
            </el-table-column>

            <el-table-column
            prop="latest_event"
            label="最近物流信息">
            </el-table-column>

            <el-table-column
            prop="ciclo"
            label="物流周期"
            width='50'>
            </el-table-column>

            <el-table-column
            prop=""
            label="来源地信息"
            width='50'>
                    Olatest_detail
                <template slot-scope="scope">
                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="LY(scope.$index, scope.row)"
                    circle
                    plain
                    ></el-button>
                </template>
            </el-table-column>

            <el-table-column
            prop=""
            label="目的地信息"
            width='50'>
            Dlatest_detail
                <template slot-scope="scope">
                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="MD(scope.$index, scope.row)"
                    circle
                    plain
                    ></el-button>
                </template>
            </el-table-column>

            <el-table-column
            prop="stay_time"
            label="停留时长"
            width='50'>
            </el-table-column>

            <el-table-column
            prop="courier_code"
            label="物流商简码"
            width='100'>
            </el-table-column>

            <el-table-column label="前往" width="50px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-position"
                  @click="look(scope.$index, scope.row)"
                  circle
                  plain
                >
                </el-button>
              </template>
            </el-table-column>

        </el-table>

        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="mytsxx"
        :page-size="mrmyts"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Total"
        style="display:flex; justify-content: center;">
        </el-pagination>

        <!-- 来源地信息对话框 -->
        <el-dialog
            title="来源地信息"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <div class="block">
                <div class="radio">
                    排序：
                    <el-radio-group v-model="reverse">
                    <el-radio :label="true">倒序</el-radio>
                    <el-radio :label="false">正序</el-radio>
                    </el-radio-group>
                </div>

                <el-timeline :reverse="reverse">
                    <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        :timestamp="activity.tracking_detail">
                    {{activity.checkpoint_date}} {{activity.location}}
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>

        <!-- 目的地信息对话框 -->
        <el-dialog
            title="目的地信息"
            :visible.sync="dialogVisible_"
            width="30%"
            :before-close="handleClose_">
            <div class="block">
                <div class="radio">
                    排序：
                    <el-radio-group v-model="reverse_">
                    <el-radio :label="true">倒序</el-radio>
                    <el-radio :label="false">正序</el-radio>
                    </el-radio-group>
                </div>

                <el-timeline :reverse="reverse_">
                    <el-timeline-item
                        v-for="(activity, index) in activities_"
                        :key="index"
                        :timestamp="activity.tracking_detail">
                    {{activity.checkpoint_date}} {{activity.location}}
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getWl } from '../../api/api';
    export default {
        data() {
            return {
                tableData: [],
                loading:true,
                dialogVisible:false,
                dialogVisible_:false,
                reverse: true,
                reverse_: true,
                activities: [],
                activities_: [],
                gjinput:'',//国际物流单号输入框
                ddinput:'',//订单id输入框
                currentPage: 1,//默认第几页
                Total:0,//总条数
                mytsxx:[10,50,100,500,1000],//每页条数选项
                mrmyts:10,//默认每页条数
                dddq:0,//到达待取
                ysgj:0,//运输过久
                knyc:0,//可能异常
                ystz:0,//运输途中
                cgqs:0,//成功签收
                tdsb:0,//投递失败
                Site:[{ 
                    label: 'madrid-shop', 
                    value: 'madrid-shop' 
                }, { 
                    label: 'cuirz', 
                    value: 'cuirz' 
                }, { 
                    label: 'nihonbro', 
                    value: 'nihonbro' 
                }, { 
                    label: 'jleague-shop', 
                    value: 'jleague-shop' 
                }, { 
                    label: 'supermaillot', 
                    value: 'supermaillot' 
                }, { 
                    label: 'fortmaillot', 
                    value: 'fortmaillot' 
                }, { 
                    label: 'kickitshirts', 
                    value: 'kickitshirts' 
                }, { 
                    label: 'mailloten', 
                    value: 'mailloten' 
                }, { 
                    label: 'honorjersey', 
                    value: 'honorjersey' 
                }, { 
                    label: 'ligafoot', 
                    value: 'ligafoot' 
                }, { 
                    label: 'beazl', 
                    value: 'beazl' 
                }, { 
                    label: 'top-w', 
                    value: 'top-w' 
                }],//店铺数组
                sitevalue:'',//显示的店铺
                packagestatus: [{
                    value: '到达待取',
                    label: '到达待取'
                }, {
                    value: '运输过久',
                    label: '运输过久'
                }, {
                    value: '可能异常',
                    label: '可能异常'
                }, {
                    value: '运输途中',
                    label: '运输途中'
                }, {
                    value: '成功签收',
                    label: '成功签收'
                }, {
                    value: '投递失败',
                    label: '投递失败'
                }],//包裹状态数组
                packagevalue: '',//显示的包裹状态
                // packagevalue: [],//显示的包裹状态
            }
        },
        created () {
            this.loading = true;
            var un = window.localStorage.getItem('un');
            if(un == '' || un == null || un == undefined){
                this.loading = true;
                return false;
            }
            var params = {
                int_no:this.gjinput,
                site:this.sitevalue,
                ID_:this.ddinput,
                delivery_status:this.packagevalue,
                limit:this.mrmyts,
                offset:this.currentPage
            }
            getWl(params).then(res => {
                // console.log(res);
                // console.log(JSON.parse(res.data[0].Dlatest_detail));
                this.tableData = res.data;
                this.Total = res.count;
                this.loading = false;
            })
        },
        methods: {

            // 查看来源地信息
            LY(index,row) {
                this.dialogVisible = true;
                this.activities = JSON.parse(row.Olatest_detail)[0].trackinfo;
            },

            // 关闭来源地信息
            handleClose() {
                this.dialogVisible = false;
            },

            // 查看目的地信息
            MD(index,row) {
                this.dialogVisible_ = true;
                this.activities_ = JSON.parse(row.Dlatest_detail)[0].trackinfo;
            },

            // 关闭目的地信息
            handleClose_() {
                this.dialogVisible_ = false;
            },

            // 通过 国际物流单号 或 订单号 查询物流轨迹
            // search(){
            //     this.loading = true;
            //     getwl(this.input).then(res => {
            //         this.tableData = res;
            //         this.Total = res.length;
            //     })
            //     this.loading = false;
            // },

            // 设置每页条数
            handleSizeChange(val) {
                this.loading = true;
                this.mrmyts = val;
                var params = {
                    int_no:this.gjinput,
                    site:this.sitevalue,
                    ID_:this.ddinput,
                    delivery_status:this.packagevalue,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }
                getWl(params).then(res => {
                    // console.log(res);
                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;
                })
            },

            // 前往第几页
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;
                var params = {
                    int_no:this.gjinput,
                    site:this.sitevalue,
                    ID_:this.ddinput,
                    delivery_status:this.packagevalue,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }
                getWl(params).then(res => {
                    // console.log(res);
                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;
                })
            },

            // 搜索
            search(){
                this.loading = true;
                var params = {
                    int_no:this.gjinput,
                    site:this.sitevalue,
                    ID_:this.ddinput,
                    delivery_status:this.packagevalue,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }
                getWl(params).then(res => {
                    
                    // console.log(res);
                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;
                })
            },

            // 前往
            look(index, row){
                const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
                window.open(routeData.href, '_blank');
            },

        },
    }
</script>

<style lang="scss" scoped>

</style>